import { render, staticRenderFns } from "./KTabsPanel.vue?vue&type=template&id=679bd6f5"
import script from "./KTabsPanel.vue?vue&type=script&lang=js"
export * from "./KTabsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports